
<select v-model="localValue" name="state" @change="update" class="quote-builder">
  <option v-if="include_blank" :value="null"></option>
  <option v-for="state in states" :value="state.abrv" :key="state.abrv">
    {{ state.name }}
  </option>
</select>
